export default "__VITE_ASSET__BZ1ucnZe__"